import { Box, Stack } from '@mui/material';
import { ReactNode } from 'react';

import { SidebarCollapseHitArea } from './SidebarCollapseHitArea';

interface SidebarFillLayoutProps {
  children: ReactNode;
  footer: ReactNode;
  isExpanded: boolean;
  onCollapseAreaClick: () => void;
}

/**
 * Sidebar column: nav items at the top, footer pinned at the bottom, and a
 * clickable gap between them that toggles collapse.
 */
export function SidebarFillLayout({
  children,
  footer,
  isExpanded,
  onCollapseAreaClick,
}: SidebarFillLayoutProps) {
  return (
    <Stack flex={1} minHeight="100%" height="100%">
      {children}
      <SidebarCollapseHitArea
        isExpanded={isExpanded}
        onClick={onCollapseAreaClick}
      />
      <Box flexShrink={0} width="100%">
        {footer}
      </Box>
    </Stack>
  );
}
